<template>
	<ToggleSimple @update:open="toggleOpen = $event">
		<template #toggle>
			<div class="left">
				<div v-if="$te(`fields.${name}.label`)" class="toggle-text">
					{{ $t(`fields.${name}.label`) }}
					<span v-if="count.selected && count.selected > 0">{{ count.selected }}</span>
				</div>
                <div v-if="$te(`fields.search_sbi.description`)" class="toggle-description">
                    {{ $t(`fields.search_sbi.description`) }}
                </div>
			</div>
			<div class="right">
				<div v-if="isActive" class="reset" @click="resetSection">
					<div class="icon-reset-pos"></div>
				</div>
				<div class="toggle-icon"></div>
			</div>
		</template>

		<template #content>
			<div class="options-sbi" :class="cssClassOptions">
                <CustomCategories
                    v-model="options"
                    inputKey="sbi"
                    :map="sbiNlData"
                    :formatCodeFunction="formatSbiCode"
                    @update:modelValue="onListsChanged"
                    expandAllLabel="company.expand_all"
                    collapseAllLabel="company.collapse_all"
                    :showDescription="false"
                    ref="categories"
                />
			</div>
		</template>
	</ToggleSimple>
</template>

<script>
	import ToggleSimple from '@/components/elements/misc/ToggleSimple';
	import CustomCategories from '@/components/elements/inputs/CustomCategories';
	import { nextTick } from 'vue';
    import { sbi_nl } from '@/utils/maps/sbi-nl';
    import { formatSbiCode } from '@/utils/formatting';

	export default {
		name: "OptionsSbi",
		components: {
			ToggleSimple,
			CustomCategories
		},
		props: {
			modelValue: {
				type: Object,
				default: () => ({ includes: [], excludes: [] })
			},
			defaultVal: {
				type: Object,
				default: () => ({ includes: [], excludes: [] })
			},
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
		},
		data() {
			return {
				name: 'sbi',
                toggleOpen: false,
				options: {
					includes: this.modelValue?.includes || [],
					excludes: this.modelValue?.excludes || []
				},
                sbiNlData: sbi_nl
			};
		},
		computed: {
			isActive() {
				return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
			},
			count() {
				return {
					total: this.options.includes.length + this.options.excludes.length,
					selected: this.options.includes.length + this.options.excludes.length,
					includes: this.options.includes.length,
					excludes: this.options.excludes.length,
				};
			}
		},
		methods: {
            formatSbiCode,
			resetSection(event = null) {
				if (event) {
					event.stopPropagation();
				}
				this.options = {
					includes: [],
					excludes: []
				};

                if(this.$refs.categories && typeof this.$refs.categories.resetSearch === 'function') {
                    this.$refs.categories.resetSearch();
                }

				this.emitUpdate();
			},
			onListsChanged(newValue) {
				this.options = newValue;
				this.emitUpdate();
			},
			emitUpdate() {
				nextTick(() => {
					this.$emit('update:modelValue', this.options);
				});
			}
		},
		watch: {
			modelValue: {
				handler(newVal) {
					this.options = {
						includes: newVal?.includes || [],
						excludes: newVal?.excludes || []
					};
				},
				deep: true,
				immediate: true
			}
		}
	}
</script>
